import { render, staticRenderFns } from "./bgcOne.vue?vue&type=template&id=6d7f003e&scoped=true"
import script from "./bgcOne.vue?vue&type=script&lang=js"
export * from "./bgcOne.vue?vue&type=script&lang=js"
import style0 from "./bgcOne.vue?vue&type=style&index=0&id=6d7f003e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f003e",
  null
  
)

export default component.exports